export default __webpack_public_path__ + "static/loop-balthazaurus-scroll-a1b3cf92ee85f65eb6d7373313446962.gif";